import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StaticHtmlDocumentService } from '../../services/static-html-document.service';
import { HtmlDocumentVersion } from '../../common/htmlDocumentVersion';
import { HtmlDocType } from '../../common/htmlDocType';

@Component({
  selector: 'app-version-history',
  templateUrl: './version-history.component.html',
  styleUrls: ['./version-history.component.scss'],
  standalone: false
})
export class VersionHistoryComponent implements OnInit {
  documentId: number | null = null;
  documentType: HtmlDocType | null = null;
  versions: HtmlDocumentVersion[] = [];
  loading = true;
  error: string | null = null;
  typeLabels: Record<HtmlDocType, string> = { [HtmlDocType.PRIVACY]: 'Datenschutz', [HtmlDocType.AGB]: 'AGB', [HtmlDocType.IMPRESSUM]: 'Impressum' };
  displayedColumns: string[] = ['validFrom', 'createdByUserId', 'actions'];
  VersionsValidFrom: Date | null = null;

  constructor(private route: ActivatedRoute, private router: Router, private documentService: StaticHtmlDocumentService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('documentId');
    if (id) {
      this.documentId = +id;
      this.loadDocumentAndVersions();
    } else {
      this.error = 'Dokument nicht angegeben.';
      this.loading = false;
    }
  }

  loadDocumentAndVersions(): void {
    if (!this.documentId) return;
    if(this.VersionsValidFrom && this.VersionsValidFrom.toString().length > 0) {
      let validFromDate = new Date(this.VersionsValidFrom);
      this.documentService.getVersionAt(this.documentId!, validFromDate.getTime().toString()).subscribe({
        next: (version) => {
          this.versions = [version];
          this.documentType = version.getDocumentType();
          this.loading = false;
          this.cd.detectChanges();
        },
        error: (err) => {
          if(err.status == 404) this.versions = []
          else this.error = err?.error?.message || 'Versionsliste konnte nicht geladen werden.';
          this.loading = false;
          this.cd.detectChanges();
        }
      });
    }
    else {
      this.documentService.getVersions(this.documentId!).subscribe({
        next: (list) => {
          this.versions = list;
          this.documentType = list[0].getDocumentType();
          this.loading = false;
          this.cd.detectChanges();
        },
        error: (err) => {
          this.error = err?.error?.message || 'Versionsliste konnte nicht geladen werden.';
          this.loading = false;
          this.cd.detectChanges();
        }
      });
    }
  }

  viewVersion(versionId: number): void {
    this.router.navigate(['versions', versionId], { relativeTo: this.route.parent });
  }

  back(): void {
    this.router.navigate(['overview'], { relativeTo: this.route.parent });
  }

  label(type: HtmlDocType): string {
    return this.typeLabels[type] || "not found";
  }

  get documentTitle(): string {
    return this.documentType != null? this.label(this.documentType) : 'not found';
  }
}
